// export const environment = {
//   production: false,
//   enableChatbot: false, is set in the environment.ts file
//   baseUrl: 'http://localhost:3000/api',
//   googleSearchEngineId: 'f6e3fe3920f0f4327',
//   trackingApiBaseUrl: 'https://link-osint-dev.face1.ai',
//   cartoApiKey: 'cb1_4xju_1_bf2513cc699b99005bc18b72',
// };


// export const environment = {
//   production: false,
//   baseUrl: 'http://localhost:3000/api',
//   googleSearchEngineId: 'f6e3fe3920f0f4327',
//   trackingApiBaseUrl: ' http://localhost:3001',
//   cartoApiKey: 'cb1_4xju_1_bf2513cc699b99005bc18b72',
//   tawkEmbedUrl: 'https://embed.tawk.to/6ae306d4f31836346f8988eb/1k63d5c28',
//   /** Set false to hide the Rio help chatbot widget. */
//   enableChatbot: true,
//   // Firebase web app (ryno-8382d).
//   // vapidKey is REQUIRED for browser FCM (same project, free):
//   // Console → Cloud Messaging → Web Push certificates → Generate key pair.
//   firebase: {
//     apiKey: 'AIzaSyB1KHH5CSFTRk-P4byK0v1m8lC9_tqELHM',
//     authDomain: 'ryno-8382d.firebaseapp.com',
//     projectId: 'ryno-8382d',
//     storageBucket: 'ryno-8382d.firebasestorage.app',
//     messagingSenderId: '54278913382',
//     appId: '1:54278913382:web:729d536b34d4fa64881ca7',
//     measurementId: 'G-GZRF75ET6N',
//     // Paste Web Push "Key pair" here — without it, web push will not register.
//     vapidKey:
//       'BFXHdYwIYYkb4uM988ESGlWO07xN0ilOqEvvo-0SfC2O_q8YdcTrjdCphCQJGrxQGYraaBzeYa7oxSbzqv6bu_M',
//   },
// };

export const environment = {
  production: false,
  baseUrl: 'https://osint-dev.face1.ai/api',
  googleSearchEngineId: 'f6e3fe3920f0f4327',
  trackingApiBaseUrl: 'https://link-osint-dev.face1.ai',
  cartoApiKey: 'cb1_4xju_1_bf2513cc699b99005bc18b72',
  // tawkEmbedUrl: 'https://embed.tawk.to/6ae306d4f31836346f8988eb/1k63d5c28',
  enableChatbot: true,
  // Firebase web app (ryno-8382d).
  // vapidKey is REQUIRED for browser FCM (same project, free):
  // Console → Cloud Messaging → Web Push certificates → Generate key pair.
  firebase: {
    apiKey: 'AIzaSyB1KHH5CSFTRk-P4byK0v1m8lC9_tqELHM',
    authDomain: 'ryno-8382d.firebaseapp.com',
    projectId: 'ryno-8382d',
    storageBucket: 'ryno-8382d.firebasestorage.app',
    messagingSenderId: '54278913382',
    appId: '1:54278913382:web:729d536b34d4fa64881ca7',
    measurementId: 'G-GZRF75ET6N',
    // Paste Web Push "Key pair" here — without it, web push will not register.
    vapidKey:
      'BFXHdYwIYYkb4uM988ESGlWO07xN0ilOqEvvo-0SfC2O_q8YdcTrjdCphCQJGrxQGYraaBzeYa7oxSbzqv6bu_M',
  },
};
